import { AppToaster, ReactBaseConfigProvider, useAuth } from '@cks-internal/react-base';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import axios from 'axios';
import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ErrorContainer } from '../ErrorContainer';
import { Box } from './components/ui/chakraPrimitives';
import { CompassUser } from './globalTypes/user/compassUser.ts';
import { useNavWithRouting } from './routes/AppRouter';
import { ChakraRootProvider } from './components/ui/provider.tsx';
import { API_URL } from './util/config.ts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: true
    }
  }
});

export const App = () => {
  const { initUser, hasLoaded } = useAuth<CompassUser>();
  const AppRouter = createBrowserRouter(useNavWithRouting());
  axios.defaults.baseURL = API_URL;
  axios.defaults.withCredentials = true;
  useEffect(() => {
    async function initAuth() {
      await initUser();
    }

    initAuth();
  }, []);

  return (
    <ChakraRootProvider>
      <ReactBaseConfigProvider config={{ baseTable: { actionColumnPosition: 'left' } }}>
        <Box maxHeight={'100vh'}>
          <QueryClientProvider client={queryClient}>
            <AppToaster />
            <ErrorContainer>{hasLoaded && <RouterProvider router={AppRouter} />}</ErrorContainer>

            <ReactQueryDevtools />
          </QueryClientProvider>
        </Box>
      </ReactBaseConfigProvider>
    </ChakraRootProvider>
  );
};
